import React from "react";
import {FieldTypeProps} from "sulu-admin-bundle/types";

export default class ExternalLink extends React.Component<FieldTypeProps<?string>> {
    render() {
        const {value} = this.props;

        if (!value) {
            return <span style={{color: "#999"}}>—</span>;
        }

        return (
            <a
                href={value}
                target="_blank"
                rel="noopener noreferrer"
            >
                {value}
            </a>
        );
    }
}
